import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SchedoraLogo } from "@/components/schedora/SchedoraLogo";

interface FullScreenStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function FullScreenState({
  title,
  description,
  actionLabel,
  actionHref,
}: FullScreenStateProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border bg-card p-8 shadow-card text-center">
        <SchedoraLogo iconOnly iconClassName="h-10 w-10 mx-auto mb-5" />
        <h1 className="text-2xl font-heading font-bold text-foreground">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{description}</p>
        {actionLabel && actionHref && (
          <Link to={actionHref} className="inline-block mt-6">
            <Button>{actionLabel}</Button>
          </Link>
        )}
      </div>
    </div>
  );
}
